import { Navigate } from "react-router-dom";
import { useRef } from "react";
import { Button } from "antd";
import AddUser from "./addUser";

const UserList = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const addUserRef = useRef(null);

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		<div className="add-user-page-container">
			<div className="add-user-header flex justify-between items-center m-2 mt-5">
				<h1 className='text-center text-xl font-semibold txt-color' style={{ margin: 0 }}>
					Add New Employee
				</h1>
				<Button
					type="primary"
					className="bg-blue-600 hover:bg-blue-700"
					onClick={() => addUserRef.current?.showQuickAddModal()}
				>
					Quick Add
				</Button>
			</div>
			<AddUser ref={addUserRef} />
		</div>
	);
};

export default UserList;
